/** One-shot move of token keys from @capacitor/preferences (UserDefaults: unencrypted,
 *  included in backups) to the iOS Keychain (go-live #11). Pure: stores are injected. */
export interface KV {
  get(k: string): Promise<string | null>
  set(k: string, v: string): Promise<void>
  remove(k: string): Promise<void>
}

export async function migrateKeys(from: KV, to: KV, keys: string[]): Promise<number> {
  let moved = 0
  for (const k of keys) {
    const legacy = await from.get(k)
    if (legacy === null) continue
    if ((await to.get(k)) === null) {
      await to.set(k, legacy)
      moved += 1
    }
    await from.remove(k)
  }
  return moved
}
